import { useCallback, useEffect, useState } from "react";
import { isLiveHostname } from "@/lib/environment";

const KEY = "sellavo-admin-extras";
const EVENT = "sellavo-admin-extras-change";

function read(): boolean {
  try {
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/**
 * Personligt läge för administratörer: som standard ser man sajten precis som
 * en vanlig inloggad användare. Extrafunktioner (test-/expertytor) syns först
 * när man slår på dem – och aldrig på den publika liveadressen.
 */
export function useAdminExtras(): {
  /** Får extrafunktionerna visas för mig just nu? */
  extras: boolean;
  /** Går det att slå på här (nej på liveadressen)? */
  available: boolean;
  setExtras: (on: boolean) => void;
} {
  const [extras, setState] = useState(false);
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const live = isLiveHostname(window.location.hostname);
    setAvailable(!live);
    const sync = () => setState(!live && read());
    sync();
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const setExtras = useCallback((on: boolean) => {
    try {
      if (on) window.localStorage.setItem(KEY, "1");
      else window.localStorage.removeItem(KEY);
    } catch {
      /* ignorera – valet är bara visuellt */
    }
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { extras, available, setExtras };
}
